import { Card } from '../ui';

type Props = {
  artifacts?: string[];
  confidence?: number;
  productCount?: number;
  status?: 'pending' | 'running' | 'complete';
};

export function BrandInitializationPanel({
  artifacts = [],
  confidence = 91,
  productCount = 847,
  status = 'complete',
}: Props) {
  return (
    <Card padding="sm" className="border-ai-200 bg-ai-50/30 dark:border-ai-900 dark:bg-ai-950/20">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-ai-600">AI Brand Initialization</p>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            {status === 'complete'
              ? `${productCount} products analyzed · ${confidence}% confidence`
              : status === 'running'
                ? 'Analyzing synchronized catalog data…'
                : 'Awaiting initial catalog sync'}
          </p>
        </div>
        {status === 'complete' && (
          <span className="rounded-full bg-success-100 px-2 py-0.5 text-xs font-medium text-success-700 dark:bg-success-950 dark:text-success-300">
            Ready
          </span>
        )}
      </div>
      {artifacts.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1">
          {artifacts.map((a) => (
            <span key={a} className="rounded border border-ai-200 bg-white/60 px-2 py-0.5 text-xs text-ai-700 dark:border-ai-800 dark:bg-slate-900/60 dark:text-ai-300">
              {a}
            </span>
          ))}
        </div>
      )}
    </Card>
  );
}
